export default __webpack_public_path__ + "static/media/start.aebeacab.gif";